import apiService from "@/services/apiService";

const actions = {
  getGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        total_record: 2,
        results: [
          {
            id: "690asd896123123ased",
            error_code: "400",
            location: "test location",
            description: "test description",
            cause_by: "Error Cause",
            created_at: "2024-03-04",
            created_by: "superadmin",
            updated_at: "2024-03-04",
            updated_by: "superadmin"
          },
          {
            id: "690asd89612321aseae",
            error_code: "500",
            location: "test location",
            description: "test description",
            cause_by: "Error Cause",
            created_at: "2024-03-04",
            created_by: "superadmin",
            updated_at: "2024-03-04",
            updated_by: "superadmin"
          },
        ]
      };
      resolve(data);
      // apiService.post('payment-aggregator-transaction-log/find-with-paging', payload)
      //   .then((response) => {
      //     commit('setErrorLogs', response.data.data);
      //     resolve(response);
      //   })
      //   .catch((error) => {
      //     console.log(error);
      //     reject(error);
      //   });
    });
    
  },
  getGuideBookDetail({ commit }, payload) {
    console.log({payload})
    return new Promise((resolve, reject) => {
      // apiService.put(`payment-aggregator-payment-method/${payload.id}/change-order`, payload.orderData)
      //   .then((response) => {
      //     resolve(response.data.data);
      //   })
      //   .catch((error) => {
      //     reject(error)
      //     console.log(error);
      //   });
    });
  },
  createGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      console.log({payload})
      // apiService.post(`payment-aggregator-transaction-log/refund`, payload)
      //   .then((response) => {
      //     resolve(response);
      //   })
      //   .catch((error) => {
      //     reject(error);
      //   });
    });
  },
  editGuideBook({ commit }, payload) {
    return new Promise((resolve, reject) => {
      // apiService.put(`payment-aggregator-payment-method/${payload.id}/change-order`, payload)
      //   .then((response) => {
      //     resolve(response.data.data);
      //   })
      //   .catch((error) => {
      //     reject(error)
      //     console.log(error);
      //   });
    });
  },
};

export default actions;
